/**
 * MODULE: _shared/frontend-shell/src/features/crm/utils/crmStageHistory.ts
 * PURPOSE: Demo stage history rows and day-span enrichment for CRM OpportunityDrawer timeline
 * DEPENDENCIES: ../types/crm.types, ../types/opportunity.types
 * PUBLIC_API: buildDemoStageHistory, enrichStageHistoryEntries
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 */

import type { StageHistoryEntry } from '../types/crm.types';
import type { Opportunity } from '../types/opportunity.types';

/** Demo timeline when deal ids are non-UUID mock rows (no dashboard API row yet). */
export function buildDemoStageHistory(o: Opportunity): StageHistoryEntry[] {
  if (o.stage === 'prospecting') {
    return enrichStageHistoryEntries([
      {
        stage: 'prospecting',
        changedAt: o.createdAtISO,
        changedBy: o.ownerId,
        changedByName: o.ownerName,
      },
    ]);
  }
  return enrichStageHistoryEntries([
    {
      stage: 'prospecting',
      changedAt: o.createdAtISO,
      changedBy: o.ownerId,
      changedByName: o.ownerName,
    },
    {
      stage: o.stage,
      changedAt: o.updatedAtISO,
      changedBy: o.ownerId,
      changedByName: o.ownerName,
    },
  ]);
}

export function enrichStageHistoryEntries(entries: StageHistoryEntry[]): StageHistoryEntry[] {
  return entries.map((e, i) => {
    if (i === 0) return { ...e, daysInStage: undefined };
    const prev = new Date(entries[i - 1].changedAt).getTime();
    const cur = new Date(e.changedAt).getTime();
    const days = Math.max(0, Math.round((cur - prev) / 86400000));
    return { ...e, daysInStage: days };
  });
}
